import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SrTourListingComment extends Component {
  static propTypes = {
    title: PropTypes.node.isRequired,
    placeholder: PropTypes.string.isRequired,
    tourGuideReportEditsByTourIdKey: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }

  _onCommentChange = (event) => {
    const { tourGuideReportEditsByTourIdKey, onChange } = this.props;
    onChange(tourGuideReportEditsByTourIdKey, event.target.value);
  }

  render() {
    const {
      title,
      placeholder,
      value,
    } = this.props;

    return (
      <div>
        <span className='headline'>{title}</span>
        <div className='sectionContent textInput'>
          <textarea
            className='sr-textarea'
            placeholder={placeholder}
            value={value}
            onChange={this._onCommentChange}
          />
        </div>
      </div>
    );
  }
}

SrTourListingComment.displayName = 'SrTourListingComment';

export default SrTourListingComment;
